import React, { useState, useEffect } from 'react';
import Constants from 'components/show_drawing/Constants.jsx';
import { Angle, Bool, Integer, Length, Select, ShowHideChildOptions } from 'components/layout/options/drawing_options/index.js';

const OptionWithChildren = ({ item, option, unit, value, onChange, enabled, doNotLoadFromLocalStorage, getOnChangeFor, getValueByName, recoveryApplyMethods }) => {
  const [childrenHidden, setChildrenHidden] = useState(true);

  const optionFactory = (childOption) => {
    let formField;

    switch(childOption.input_type) {
      case 'integer':
        formField = <Integer
          key={childOption.id}
          item={item}
          option={childOption}
          value={getValueByName(childOption.name)}
          onChange={getOnChangeFor(childOption)}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;

      case 'length':
        formField = <Length
          key={childOption.id}
          item={item}
          option={childOption}
          unit={unit}
          value={getValueByName(childOption.name)}
          onChange={getOnChangeFor(childOption)}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;

      case 'boolean':
        formField = <Bool
          key={childOption.id}
          item={item}
          option={childOption}
          value={getValueByName(childOption.name)}
          onChange={getOnChangeFor(childOption)}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;

      case 'angle':
        formField = <Angle
          key={childOption.id}
          item={item}
          option={childOption}
          value={getValueByName(childOption.name)}
          onChange={getOnChangeFor(childOption)}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;

      case 'select':
        formField = <Select
          key={childOption.id}
          item={item}
          option={childOption}
          value={getValueByName(childOption.name)}
          onChange={getOnChangeFor(childOption)}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;
    }

    return formField;
  };

  const parentOptionFactory = () => {
    let formField;

    switch(option.input_type) {
      case 'integer':
        formField = <Integer
          key={option.id}
          item={item}
          option={option}
          value={value}
          onChange={onChange}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;

      case 'length':
        formField = <Length
          key={option.id}
          item={item}
          option={option}
          unit={unit}
          value={value}
          onChange={onChange}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;

      case 'boolean':
        formField = <Bool
          key={option.id}
          item={item}
          option={option}
          value={value}
          onChange={onChange}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;

      case 'angle':
        formField = <Angle
          key={option.id}
          item={item}
          option={option}
          value={value}
          onChange={onChange}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;

      case 'select':
        formField = <Select
          key={option.id}
          item={item}
          option={option}
          value={value}
          onChange={onChange}
          enabled={enabled}
          doNotLoadFromLocalStorage={doNotLoadFromLocalStorage}
        />
        break;
    }

    return formField;
  };

  const childOptionVisibleChangeMsg = (event) => {
    if(event.detail.item_uuid === item.uuid && event.detail.name === option.name) {
      setChildrenHidden(() => !event.detail.visible);
    }
  };

  const onRecoverySetValueHighlightMsg = (event) => {
    if(event.detail.item_uuid !== item.uuid) { return; }
    const rule = event.detail.rule;
    const apply_to_names = (rule.recovery_apply_to || []).map(recovery => recovery.name);
    const isOurChild = option.children.some(child => apply_to_names.includes(child.name));
    if(isOurChild) {
      setChildrenHidden(() => false);
    }
  };

  useEffect(() => {
    const handleVisibleChange = (event) => childOptionVisibleChangeMsg(event);
    const handleRecoveryHighlight = (event) => onRecoverySetValueHighlightMsg(event);

    document.addEventListener(Constants.child_options_visible_change, handleVisibleChange);
    document.addEventListener(Constants.drawing_recovery_set_value_highlight_required, handleRecoveryHighlight);

    return () => {
      document.removeEventListener(Constants.child_options_visible_change, handleVisibleChange);
      document.removeEventListener(Constants.drawing_recovery_set_value_highlight_required, handleRecoveryHighlight);
    };
  }, [item.uuid, option.name, option.children]);

  // Set recovery apply methods for children
  useEffect(() => {
    if(recoveryApplyMethods) {
      option.children.forEach((childOption) => {
        recoveryApplyMethods.current[childOption.name] = getOnChangeFor(childOption);
      });
    }
  }, [option.children, recoveryApplyMethods]);

  return (
    <div>
      {parentOptionFactory()}
      <ShowHideChildOptions item={item} option={option} />
      {!childrenHidden && (
        <div className="LayoutChildOption">
          {option.children.map((childOption) => optionFactory(childOption))}
        </div>
      )}
    </div>
  );
};

export default OptionWithChildren;
